import { render, staticRenderFns } from "./JoinBanner.vue?vue&type=template&id=cecb8c04&scoped=true&"
import script from "./JoinBanner.vue?vue&type=script&lang=js&"
export * from "./JoinBanner.vue?vue&type=script&lang=js&"
import style0 from "./JoinBanner.vue?vue&type=style&index=0&id=cecb8c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecb8c04",
  null
  
)

export default component.exports